import { Injectable } from "@angular/core";
import { NGXLogger } from "ngx-logger";
import { Observable, BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class SharedDataService {
    private currentPage = new Subject<any>();
    private CssModuleName = new Subject<any>();
    private userTokens = new BehaviorSubject<any>([]);
    private alert = new BehaviorSubject<any>([]);
    private modalAlert = new BehaviorSubject<any>([]);
    public crewContactSearchFlyout: Subject<boolean> = new Subject<any>();

    private buAccess = new BehaviorSubject<any>([]);
  private selectedBusinessUnit = new BehaviorSubject<any>([]);

  contactFlyoverSubject: Subject<{}> = new Subject<{}>();

  getFlyOverStatus(): Observable<any> {
    return this.contactFlyoverSubject.asObservable();
  }

  setFlyOverStatus(data) {
    return this.contactFlyoverSubject.next(data);
  }

    constructor(private log: NGXLogger) {}

    getBuAccess(): Observable<any> {
        return this.buAccess.asObservable();
    }

    setBuAccess(buAccess) {
        this.buAccess.next(buAccess);
    }

    getSelectedBusinessUnit(): Observable<any> {
        return this.selectedBusinessUnit.asObservable();
    }
    setSelectedBusinessUnit(selectedBu: any) {
        this.selectedBusinessUnit.next(selectedBu);
    }

    setCurrentPage(pageName: any) {
        this.currentPage.next(pageName);
    }

    getCurrentPage(): Observable<any> {
        return this.currentPage.asObservable();
    }

    setCss(moduleName: any) {
        this.log.trace("SharedDataService - CssModuleName " + moduleName);
        this.CssModuleName.next(moduleName);
    }

    getCss(): Observable<any> {
        return this.CssModuleName.asObservable();
    }
    //*************************** START:  ACCESS TOKENS ***********************************************************************/
    //Set users tokens for UI validation
    setUserTokens(usertokens: any) {
        this.log.trace("updated tokens received");
        this.userTokens = usertokens;
    }

    // get all the latest user tokens for UI validation
    getUserTokens(): Observable<any> {
        return this.userTokens.asObservable();
    }

    //*************************  START : ALERT *****************************************************************/
    showAlert(alert: any) {
        this.log.trace("alert received" + alert);
        // this.alert = new BehaviorSubject<any>([]);
        this.alert.next(alert);
    }

    getAlertMessage(): Observable<any> {
        return this.alert.asObservable();
    }

    removeAlert() {
        let existingalerts = this.alert.getValue();
        existingalerts = new BehaviorSubject<any>([]);
        this.alert.next(existingalerts);
    }

    clearAlert(alert: any) {
        this.log.trace("alert clear" + alert);
        // this.alert = new BehaviorSubject<any>([]);
        this.alert.next(alert);
    }

    showModalAlert(alert: any) {
        this.log.trace("alert received" + alert);
        this.modalAlert.next(alert);
    }

    getModalAlertMessage(): Observable<any> {
        return this.modalAlert.asObservable();
    }

    removeModalAlert() {
        let existingalerts = this.modalAlert.getValue();
        existingalerts = new BehaviorSubject<any>([]);
        this.modalAlert.next(existingalerts);
    }
}
